import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table
} from "reactstrap";

const InvoiceTab = () => {
  const [filters, setFilters] = useState({
    fromServiceDate: "",
    toServiceDate: "",
    fromSubmissionDate: "",
    toSubmissionDate: "",
    claimStatus: "All"
  });

  const [invoices] = useState([
    {
      dateOfService: "27/06/2025",
      invoiceNo: "2506/000022",
      invoiceDate: "27/06/2025",
      patient: "MUSA NGOETJANA",
      status: "Cash",
      invoiceTotal: "R 1,500.00",
      medAidLiable: "R 0.00",
      patientLiable: "R 1,500.00"
    }
  ]);

  const handleInputChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              {/* Filters */}
              <Row className="align-items-end">
                <Col lg={6}>
                 <div className="mb-3">
                    <Label>From date of service</Label>
                  <Input
                    type="date"
                    name="fromServiceDate"
                    value={filters.fromServiceDate}
                    onChange={handleInputChange}
                  />
                 </div>
                  
                </Col>
                <Col lg={6}>
                <div className="mb-3"><Label>To date of service</Label>
                  <Input
                    type="date"
                    name="toServiceDate"
                    value={filters.toServiceDate}
                    onChange={handleInputChange}
                  /></div>
                  
                </Col>
                <Col lg={6}>
                <div className="mb-3"><Label>From date of submission</Label>
                  <Input
                    type="date"
                    name="fromSubmissionDate"
                    value={filters.fromSubmissionDate}
                    onChange={handleInputChange}
                  /></div>
                  
                </Col>
                <Col lg={6}>
                <div className="mb-3">
                    <Label>To date of submission</Label>
                  <Input
                    type="date"
                    name="toSubmissionDate"
                    value={filters.toSubmissionDate}
                    onChange={handleInputChange}
                  />
                </div>
                  
                </Col>
              </Row>

              <Row className="mt-1">
                <Col lg={3}>
                  <Label>Claim status</Label>
                  <Input
                    type="select"
                    name="claimStatus"
                    value={filters.claimStatus}
                    onChange={handleInputChange}
                  >
                    <option>All</option>
                    <option>Pending</option>
                    <option>Approved</option>
                    <option>Rejected</option>
                  </Input>
                </Col>
                <Col lg={9} className="d-flex align-items-end justify-content-end">
                  <Button color="secondary" className="me-2">
                    Clear
                  </Button>
                  <Button color="warning">Search</Button>
                </Col>
              </Row>

              {/* Invoice Table */}
              <Table bordered hover responsive className="mt-4">
                <thead>
                  <tr>
                    <th>Date of Service</th>
                    <th>Invoice No.</th>
                    <th>Invoice Date</th>
                    <th>Patient</th>
                    <th>Status</th>
                    <th>Invoice Total</th>
                    <th>Med Aid Liable</th>
                    <th>Patient Liable</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((inv, index) => (
                    <tr key={index}>
                      <td>{inv.dateOfService}</td>
                      <td>{inv.invoiceNo}</td>
                      <td>{inv.invoiceDate}</td>
                      <td>{inv.patient}</td>
                      <td>{inv.status}</td>
                      <td>{inv.invoiceTotal}</td>
                      <td>{inv.medAidLiable}</td>
                      <td className="text-danger">{inv.patientLiable}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <Button color="link" disabled>
                    «
                  </Button>
                  <Button color="link" active>
                    1
                  </Button>
                  <Button color="link" disabled>
                    »
                  </Button>
                </div>
                <Button color="dark">Close</Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default InvoiceTab;
